module.exports = __webpack_public_path__ + "static/media/incidentActive.4729b771.png";